import React, { useEffect, useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';
import type { i18n } from 'i18next';
import { initI18n } from '../config';
import type { Locale } from '../types';

export interface I18nProviderProps {
  children: React.ReactNode;
  locale?: Locale;
  /** i18next detection plugin (e.g. i18next-browser-languagedetector for web) */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  detector?: any;
  /** For mobile: pass a pre-detected locale from expo-localization */
  deviceLocale?: string;
  /** For mobile: callback to persist locale choice */
  onLocaleChange?: (locale: Locale) => void;
}

export function I18nProvider({
  children,
  locale,
  detector,
  deviceLocale,
  onLocaleChange: _onLocaleChange,
}: I18nProviderProps) {
  const i18nInstance: i18n = useMemo(() => {
    return initI18n({
      locale: locale ?? (deviceLocale as Locale | undefined),
      detector,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (locale && i18nInstance.language !== locale) {
      i18nInstance.changeLanguage(locale);
    }
  }, [locale, i18nInstance]);

  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
}
